var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { class: [_vm.classes], attrs: { col_key: _vm.col_key } }, [
    _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "custom-control custom-switch pl-5" }, [
        _c("input", {
          staticClass: "custom-control-input table_selector_input",
          attrs: {
            type: "checkbox",
            id: _vm.table_id + "_" + _vm.element_id + "_selector_input",
          },
          domProps: { value: _vm.element_id },
        }),
        _vm._v(" "),
        _c("label", {
          staticClass: "custom-control-label",
          attrs: {
            for: _vm.table_id + "_" + _vm.element_id + "_selector_input",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }